import { render } from "./forgot-client.vue?vue&type=template&id=0f8b38ba"
import script from "./forgot-client.vue?vue&type=script&lang=js"
export * from "./forgot-client.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__